import React from 'react';
import {StyleSheet, Image, Text} from 'react-native';

export default function Loading(props) {
  return (
    <Image
      uri={process.env.PUBLIC_URL + '/assets/loading.gif'}
      source={process.env.PUBLIC_URL + '/assets/loading.gif'}
      style={styles.imageStyle}
      resizeMode={'contain'}
    />
  );
}

const styles = StyleSheet.create({
  imageStyle: {height: 100, width: 70, alignSelf: 'center'},
});
